import { initialize } from "@epc-front/shared/services/router";

import routes from "../config/routes";

export const router = initialize(routes);
